import { render, staticRenderFns } from "./DynamicLinkRedirect.vue?vue&type=template&id=60cb2c64&"
import script from "./DynamicLinkRedirect.vue?vue&type=script&lang=js&"
export * from "./DynamicLinkRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports